var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOffice3 = function SvgOffice3(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 11.27 11.9 0h-2v15H.2a.2.2 0 0 0-.2.2v16.6c0 .11.09.2.2.2h26.5a.2.2 0 0 0 .2-.2V12.2a.2.2 0 0 0-.2-.2h-1.6a.2.2 0 0 0-.2.2v17.6a.2.2 0 0 1-.2.2H12.1a.2.2 0 0 1-.2-.2V4.46l-1.45-.84 1-1.73.45.26L30.9 13c.1.06.22.02.27-.07l.8-1.39c.06-.09.03-.22-.07-.27M9.9 29.8a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2V17.2c0-.11.09-.2.2-.2h7.5c.11 0 .2.09.2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15h-7v8h7zm-5 2h3v4h-3z"
  })));
};
export default SvgOffice3;